<template>
  <!-- Override -->
  <div class="tw-mb-[30px]">
    <p class="tw-mb-[10px] tw-text-[#211F58] tw-text-[15px] tw-font-semibold">
      {{ getComponentUiText("app-component-assessments-override-title-1") }}
    </p>

    <div style="background-color: white">
      <div
        class="tw-p-[15px] tw-border-b-[0px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1] tw-rounded-t-md"
      >
        <PercentInput
          :value="checklistItemComplianceOverrideValue"
          data-cy-id="assessment-bulk-answer-compliance-override-value"
          hint-text="%"
          :label="
            'Compliance Override' ||
            getComponentUiText(
              'app-component-assessments-question-type-2-override-label-1',
            )
          "
          :is-in-range100="true"
          :class-text="defaultOverrideClass"
          :class-input="'!tw-min-w-[50px] md:!tw-min-w-[80px] !tw-min-h-[44px] tw-text-[13px] tw-font-normal !tw-bg-[rgba(239,240,241,0.5)]'"
          @on:blur="
            () => {
              handleUpdateData({
                [ASSESSMENT_ANSWER_STORE_TYPE.COMPLIANCE_OVERRIDE]:
                  checklistItemComplianceOverrideValue,
              });
            }
          "
          @update:model-value="
            (value) => {
              checklistItemComplianceOverrideValue = (
                parseFloat(value) / 100 || 0
              ).toFixed(2);
            }
          "
        />
      </div>

      <div
        class="tw-p-[15px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1] tw-rounded-b-md"
      >
        <PercentInput
          :value="checklistItemCompensatingControlValue"
          data-cy-id="assessment-bulk-answer-compensating-value"
          hint-text="%"
          :is-in-range100="true"
          :class-text="defaultControlClass"
          :label="
            getComponentUiText(
              'app-component-assessments-question-type-2-compensating-controls-label-1',
            )
          "
          :class-input="'!tw-min-w-[50px] md:!tw-min-w-[80px] !tw-min-h-[44px] tw-text-[13px] tw-font-normal !tw-bg-[rgba(239,240,241,0.5)]'"
          @on:blur="
            () => {
              handleUpdateData({
                [ASSESSMENT_ANSWER_STORE_TYPE.COMPENSATING_CONTROL]:
                  checklistItemCompensatingControlValue,
              });
            }
          "
          @update:model-value="
            (value) => {
              checklistItemCompensatingControlValue = (
                parseFloat(value) / 100 || 0
              ).toFixed(2);
            }
          "
        />
      </div>
    </div>
  </div>

  <!-- Attributes -->
  <div class="tw-mb-[30px]">
    <p class="tw-mb-[10px] tw-text-[#211F58] tw-text-[15px] tw-font-semibold">
      {{ "Attributes" }}
    </p>

    <div style="background-color: white">
      <div
        class="tw-flex tw-items-center tw-px-[15px] tw-py-[12px] tw-border-b-[0px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1] tw-rounded-t-md"
      >
        <div class="tw-flex-1">
          <Importance
            :class="[
              'info-icon',
              'Cost',
              'tw-text-[#231F20]',
              'tw-scale-[0.856]',
              'tw-mr-[10px]',
            ]"
          />
          <span class="tw-text-[13px] tw-min-w-[110px] tw-font-[500]">{{
            getComponentUiText("app-component-table-header-importance-1")
          }}</span>
        </div>

        <div class="dropdown-container tw-flex-1 dropdown">
          <CustomBDropDown
            :id="'importanceOption'"
            :data="importanceRef"
            :class-text-name="`${classImportanceName}`"
            :class-name="
              'gray-dropdown-container tw-h-[44px] gray-dropdown-container-advance ' +
              'white-background'
            "
            :placeholder="
              getComponentUiText(
                'app-component-assessments-assessment-question-chose-answer-prompt-1',
              )
            "
          >
            <CustomBDropDownItem
              v-for="(item, index) in importanceDropdownData"
              :key="index"
              :data="item"
              :class-name="`normal-dropdown-container ${
                item.id
                  ? `${CHECKLIST_ICON_VALUE_WITH_COLOR[`${item.id}`]}`
                  : 'tw-text-[#231F20]'
              }`"
              @click="handleImportanceSelected(item)"
            />
          </CustomBDropDown>
        </div>
      </div>

      <div
        class="tw-flex tw-items-center tw-px-[15px] tw-py-[12px] tw-border-b-[0px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1]"
      >
        <div class="tw-flex-1">
          <Impact
            :class="[
              'info-icon',
              'Cost',
              'tw-text-[#231F20]',
              'tw-scale-[0.856]',
              'tw-mr-[10px]',
            ]"
          />
          <span class="tw-text-[13px] tw-min-w-[110px] tw-font-[500]">{{
            getComponentUiText(
              "app-component-assessments-question-type-2-icon-tooltip-impact-1",
            )
          }}</span>
        </div>
        <div class="dropdown-container tw-flex-1 dropdown">
          <CustomBDropDown
            :id="'impactOption'"
            :data="impactRef"
            :class-text-name="`${classImpactName}`"
            :class-name="
              'gray-dropdown-container tw-h-[44px] gray-dropdown-container-advance ' +
              'white-background'
            "
            :placeholder="
              getComponentUiText(
                'app-component-assessments-assessment-question-chose-answer-prompt-1',
              )
            "
          >
            <CustomBDropDownItem
              v-for="(item, index) in impactDropdownData"
              :key="index"
              :data="item"
              :class-name="`normal-dropdown-container ${
                item.id
                  ? `${CHECKLIST_ICON_VALUE_WITH_COLOR[`${item.id}`]}`
                  : 'tw-text-[#231F20]'
              }`"
              @click="handleImpactSelected(item)"
            />
          </CustomBDropDown>
        </div>
      </div>

      <div
        class="tw-flex tw-items-center tw-px-[15px] tw-py-[12px] tw-border-b-[0px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1]"
      >
        <div class="tw-flex-1">
          <Cost
            :class="[
              'info-icon',
              'Cost',
              'tw-text-[#231F20]',
              'tw-scale-[0.856]',
              'tw-mr-[10px]',
            ]"
          />
          <span class="tw-text-[13px] tw-min-w-[110px] tw-font-[500]">{{
            getComponentUiText(
              "app-component-assessments-question-type-2-icon-tooltip-cost-1",
            )
          }}</span>
        </div>
        <div class="dropdown-container tw-flex-1 dropdown">
          <CustomBDropDown
            :id="'costOption'"
            :data="costRef"
            :class-text-name="`${classCostName}`"
            :class-name="
              'gray-dropdown-container tw-h-[44px] gray-dropdown-container-advance ' +
              'white-background'
            "
            :placeholder="
              getComponentUiText(
                'app-component-assessments-assessment-question-chose-answer-prompt-1',
              )
            "
          >
            <CustomBDropDownItem
              v-for="(item, index) in costDropdownData"
              :key="index"
              :data="item"
              :class-name="`normal-dropdown-container ${
                item.id
                  ? `${CHECKLIST_ICON_VALUE_WITH_COLOR[`${item.id}`]}`
                  : 'tw-text-[#231F20]'
              }`"
              @click="handleCostSelected(item)"
            />
          </CustomBDropDown>
        </div>
      </div>

      <div
        class="tw-flex tw-items-center tw-px-[15px] tw-py-[12px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1]"
        style="border-bottom-left-radius: 6px; border-bottom-right-radius: 6px"
      >
        <div class="tw-flex-1">
          <Effort
            :class="[
              'info-icon',
              'Cost',
              'tw-text-[#231F20]',
              'tw-scale-[0.856]',
              'tw-mr-[10px]',
            ]"
          />
          <span class="tw-text-[13px] tw-min-w-[110px] tw-font-[500]">{{
            getComponentUiText(
              "app-component-assessments-question-type-2-icon-tooltip-effort-1",
            )
          }}</span>
        </div>
        <div class="dropdown-container tw-flex-1 dropdown">
          <CustomBDropDown
            :id="'effortOption'"
            :data="effortRef"
            :class-text-name="`${classEffortName}`"
            :class-name="
              'gray-dropdown-container tw-h-[44px] gray-dropdown-container-advance ' +
              'white-background'
            "
            :placeholder="
              getComponentUiText(
                'app-component-assessments-assessment-question-chose-answer-prompt-1',
              )
            "
          >
            <CustomBDropDownItem
              v-for="(item, index) in effortDropdownData"
              :key="index"
              :data="item"
              :class-name="`normal-dropdown-container ${
                item.id
                  ? `${CHECKLIST_ICON_VALUE_WITH_COLOR[`${item.id}`]}`
                  : 'tw-text-[#231F20]'
              }`"
              @click="handleEffortSelected(item)"
            />
          </CustomBDropDown>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ASSESSMENT_ANSWER_STORE_TYPE,
  CHECKLIST_ICON_VALUE_WITH_COLOR,
} from "@/utils/constants";
import { getComponentUiText } from "@/utils/utilities";
import { computed, onMounted, ref, Ref } from "vue";
import PercentInput from "../common/percentInput.vue";
import store from "@/store";
import CustomBDropDown from "@/components/common/customBDropDown.vue";
import Effort from "@/components/svgs/effort.vue";
import CustomBDropDownItem from "@/components/common/customBDropDownItem.vue";
import Impact from "@/components/svgs/impact.vue";
import Importance from "@/components/svgs/importance.vue";
import Cost from "@/components/svgs/cost.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";

const props = defineProps({
  handleUpdateData: {
    type: Function,
    default: () => {},
  },
});

const inputLabelGray = "!tw-text-[#878787] tw-text-[13px] tw-font-normal";
const inputLabelBlack = "!tw-text-[#231F20] tw-text-[13px] tw-font-normal";

const checklistItemComplianceOverrideValue = ref("0.8");
const checklistItemCompensatingControlValue = ref("");
const defaultOverrideClass = computed(() => {
  const numOverride = parseFloat(checklistItemComplianceOverrideValue.value);
  const numControl = parseFloat(checklistItemCompensatingControlValue.value);
  return numControl > 0 || numOverride === 0 ? inputLabelGray : inputLabelBlack;
});
const defaultControlClass = computed(() => {
  const numControl = parseFloat(checklistItemCompensatingControlValue.value);
  return numControl === 0 ? inputLabelGray : inputLabelBlack;
});

const importanceRef: Ref<IDropDownData[]> = ref([]);
const costRef: Ref<IDropDownData[]> = ref([]);
const impactRef: Ref<IDropDownData[]> = ref([]);
const effortRef: Ref<IDropDownData[]> = ref([]);

let classImportanceName = ref("");
let classCostName = ref("");
let classImpactName = ref("");
let classEffortName = ref("");

const importanceDropdownData: any = computed(
  () => store.state.Assessment.importanceAssessment,
);
const impactDropdownData: any = computed(
  () => store.state.Assessment.impactAssessment,
);
const effortDropdownData: any = computed(
  () => store.state.Assessment.effortAssessment,
);
const costDropdownData: any = computed(
  () => store.state.Assessment.costAssessment,
);

onMounted(() => initialData());

const initialData = () => {
  props.handleUpdateData({
    [ASSESSMENT_ANSWER_STORE_TYPE.COMPLIANCE_OVERRIDE]:
      checklistItemComplianceOverrideValue.value,
    [ASSESSMENT_ANSWER_STORE_TYPE.COMPENSATING_CONTROL]:
      checklistItemCompensatingControlValue.value,
  });
  handleImportanceSelected({
    id: "vh",
    name: "Very High",
  });
  handleImpactSelected({
    id: "vh",
    name: "Very High",
  });
  handleCostSelected({
    id: "m",
    name: "Medium",
  });
  handleEffortSelected({
    id: "l",
    name: "Low",
  });
};
const handleImportanceSelected = (event: IDropDownData) => {
  importanceRef.value = [event];
  classImportanceName.value = event.id
    ? CHECKLIST_ICON_VALUE_WITH_COLOR[`${event.id}`]
    : "tw-text-[#231F20]";
  props.handleUpdateData({
    [ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_IMPORTANCE]: event.id,
  });
};

const handleImpactSelected = (event: IDropDownData) => {
  impactRef.value = [event];
  classImpactName.value = event.id
    ? CHECKLIST_ICON_VALUE_WITH_COLOR[`${event.id}`]
    : "tw-text-[#231F20]";
  props.handleUpdateData({
    [ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_IMPACT]: event.id,
  });
};

const handleCostSelected = (event: IDropDownData) => {
  costRef.value = [event];
  classCostName.value = event.id
    ? CHECKLIST_ICON_VALUE_WITH_COLOR[`${event.id}`]
    : "tw-text-[#231F20]";
  props.handleUpdateData({
    [ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_COST]: event.id,
  });
};

const handleEffortSelected = (event: IDropDownData) => {
  effortRef.value = [event];
  classEffortName.value = event.id
    ? CHECKLIST_ICON_VALUE_WITH_COLOR[`${event.id}`]
    : "tw-text-[#231F20]";
  props.handleUpdateData({
    [ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_EFFORT]: event.id,
  });
};
</script>
<style lang="scss" scoped>
.gray-dropdown-container {
  .btn-secondary {
    padding: 12px;
  }
}
</style>
